import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Popover } from '@material-ui/core';

import Paper from 'components/Paper';
import { LoadingPage } from 'components/Loading';
import Images from 'assets/img';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import Button from 'components/Button';
import ProfilesActions from 'store/ducks/profiles';
import { Row } from 'styles/components';

import { Container, WrapperTable, WrapperPopover, PopoverText, PopoverButton, EditIcon, DeleteIcon, AddButton } from './styles';

function Profiles() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { profiles, isLoading } = useSelector((state) => state.profiles);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(ProfilesActions.getProfilesRequest());
  }, [dispatch]);

  const data = profiles.map((item) => ({
    ...item,
    actions: item.id,
    id: item.id,
    nome: item.nome || '-',
    descricao: item.descricao || '-',
    ativo: item.ativo ? 'Sim' : 'Não',
    date: item.created_at ? new Date(item.created_at) : new Date(),
  }));

  const filteredData = data.filter(
    (item) =>
      (item.nome || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.descricao || '').toUpperCase().includes(search.toUpperCase())
  );

  const handleDeleteProfile = (id) => {
    if (window.confirm('Tem certeza que deseja excluir este perfil?')) {
      dispatch(ProfilesActions.removeProfileRequest(id));
      setAnchorEl(null);
      setSelectedId(null);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setSelectedId(null);
  };

  return (
    <Container>
      <Paper
        title="PERFIS DE USUÁRIO"
        icon={Images.IconUserGear}
        rightContent={
          <Row>
            <SearchInput
              onChange={(e) => setSearch(e.target.value)}
              onClear={() => setSearch('')}
              value={search}
            />
            <AddButton onClick={() => history.push('/profiles/new')}>
              <Button label="Novo Perfil" />
            </AddButton>
          </Row>
        }
      >
        <WrapperTable>
          {isLoading ? (
            <LoadingPage />
          ) : (
            <Table
              columns={[
                { label: 'Ações', id: 'actions' },
                { label: 'Nome', id: 'nome' },
                { label: 'Descrição', id: 'descricao' },
                { label: 'Ativo', id: 'ativo' },
                { label: 'Data de cadastro', id: 'date' },
              ]}
              activePage={0}
              totalPages={1}
              data={filteredData}
              customComponent={{
                actions: (id) => (
                  <Row>
                    <EditIcon
                      onClick={() => {
                        history.push(`/profiles/edit/${id}`);
                      }}
                    />
                    <DeleteIcon
                      onClick={(e) => {
                        setSelectedId(id);
                        setAnchorEl(e.currentTarget);
                      }}
                    />
                  </Row>
                ),
                date: (date) => format(date, 'dd/MM/yyyy'),
              }}
              noNavigator
            />
          )}
        </WrapperTable>

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <WrapperPopover>
            <PopoverText>Deseja realmente excluir este perfil?</PopoverText>
            <PopoverButton onClick={() => handleDeleteProfile(selectedId)}>
              Sim
            </PopoverButton>
            <PopoverButton onClick={handleClosePopover}>Não</PopoverButton>
          </WrapperPopover>
        </Popover>
      </Paper>
    </Container>
  );
}

export default Profiles;

